var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformStatsTileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1334 57.2L38.3168 46.0166L45.6501 53.35L59.7209 39.4166V46.6125H64.9918V30.3416H48.7209V35.6125H55.9168L45.6501 45.8791L38.3168 38.5458L23.4668 53.5333L27.1334 57.2ZM16.6834 76.5875C15.2797 76.5875 14.0505 76.0598 12.9957 75.0044C11.9403 73.9496 11.4126 72.7204 11.4126 71.3166V16.6833C11.4126 15.2796 11.9403 14.0503 12.9957 12.9956C14.0505 11.9402 15.2797 11.4125 16.6834 11.4125H71.3168C72.7205 11.4125 73.9497 11.9402 75.0045 12.9956C76.0599 14.0503 76.5876 15.2796 76.5876 16.6833V71.3166C76.5876 72.7204 76.0599 73.9496 75.0045 75.0044C73.9497 76.0598 72.7205 76.5875 71.3168 76.5875H16.6834ZM16.6834 71.3166H71.3168V16.6833H16.6834V71.3166Z",
    fill: "#1B51A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformStatsTileIcon);
export default __webpack_public_path__ + "static/media/platform_stats_tile_icon.d68fb0ca0439249d8742d1b5ef9e1e51.svg";
export { ForwardRef as ReactComponent };